import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import api from './api'
import apilog from './apilog'
import book from './book'
import history from './history'
import org from './org'
import register from './register'
import user from './user'

Vue.use(Vuex)

export default new Vuex.Store({
  // 開発時は厳格モード
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    api,
    apilog,
    book,
    history,
    org,
    register,
    user
  },

  plugins: [
    // book を session storage へ永続化する
    createPersistedState({
      key: 'rac:bookin:book',
      paths: ['book'],
      storage: sessionStorage
    }),

    // history を session storage へ永続化する
    createPersistedState({
      key: 'rac:bookin:history',
      paths: ['history'],
      storage: sessionStorage
    }),

    // user, register を session storage へ永続化する
    createPersistedState({
      key: 'rac:bookin:user',
      paths: ['user', 'register'],
      storage: sessionStorage
    })
  ]
})

Vue.mixin({
  computed: {
    getters () {
      return this.$store.getters
    },
    commit () {
      return this.$store.commit
    },
    dispatch () {
      return this.$store.dispatch
    }
  }
})
